// extracted by mini-css-extract-plugin
module.exports = {"periode":"ob_Y5zfdc"};